import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { RefreshCw } from "lucide-react";
import { AssetImage } from "../AssetImage";

// What the table shows while there is no state yet: a branded card, never a black screen with four grey words.
// `status`: connecting | open | closed | auth | gone (from useTableSocket).
export const TableConnecting = ({ status, attempt = 0 }) => {
  const [secs, setSecs] = useState(0);
  useEffect(() => {
    const iv = setInterval(() => setSecs((s) => s + 1), 1000);
    return () => clearInterval(iv);
  }, []);
  const expired = status === "auth";
  const gone = status === "gone";
  return (
    <div data-testid="table-loading" data-status={status} className="h-screen w-screen flex items-center justify-center p-6 bg-slate-950">
      <div className="gold-card rounded-2xl p-7 max-w-md w-full flex flex-col items-center gap-4 text-center">
        <AssetImage id="logo_emblem" width={96} className="opacity-90" />
        {expired ? (
          <>
            <div className="font-display text-lg text-amber-50">Your sign-in expired</div>
            <p className="text-sm text-slate-300">Your seat and chips are safe. Sign in again and come straight back to the table.</p>
            <Link to="/" data-testid="loading-signin" className="btn-gold rounded-full px-5 py-2 text-sm font-display tracking-wider btn-lift">SIGN IN</Link>
          </>
        ) : gone ? (
          <>
            <div className="font-display text-lg text-amber-50">This table has closed</div>
            <p className="text-sm text-slate-300">Nothing was lost — any chips at the seat went back to your balance.</p>
            <Link to="/lobby" data-testid="loading-lobby" className="btn-gold rounded-full px-5 py-2 text-sm font-display tracking-wider btn-lift">BACK TO LOBBY</Link>
          </>
        ) : (
          <>
            <div className="font-display text-lg text-amber-50 flex items-center gap-2">
              <RefreshCw className="w-4 h-4 animate-spin text-amber-300" />
              {status === "connecting" && attempt === 0 ? "Taking your seat…" : "Reconnecting to your table…"}
            </div>
            <p className="text-sm text-slate-300">
              Your seat, your chips and the hand in progress live on the server — nothing is lost while this reconnects.
              {attempt > 0 && <span className="block text-xs text-slate-400 mt-1">attempt {attempt + 1} · {secs}s</span>}
            </p>
            <div className="flex gap-2 pt-1">
              <button type="button" data-testid="loading-reload" onClick={() => window.location.reload()}
                className="btn-gold rounded-full px-4 py-2 text-xs font-display tracking-wider btn-lift">TRY AGAIN NOW</button>
              <Link to="/lobby" data-testid="loading-lobby" className="rounded-full px-4 py-2 text-xs font-display tracking-wider border border-slate-600 hover:border-slate-400">LOBBY</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
